module.exports = __webpack_public_path__ + "static/media/tooltip.4876cecb.svg";